import { Control } from "react-hook-form";

import { ui } from "@patient-watch/ui";
import type { LooseRHFField } from "./utils/loose-rhf-field";

interface Props {
    control: Control;
}

const PIFU = (props: Props) => {
    return (
        <ui.FormField
            control={props.control}
            name="pifu"
            render={({ field }: { field: LooseRHFField }) => (
                <ui.FormItem className="bg-white p-4 border border-slate-200 rounded-md">
                    <div className="flex flex-col justify-start items-start space-y-1">
                        <div className="flex justify-center items-center gap-x-2 mb-2">
                            <ui.FormControl>
                                <ui.Checkbox checked={field.value} onCheckedChange={field.onChange} />
                            </ui.FormControl>
                            <ui.FormLabel>Use PIFU Pathway</ui.FormLabel>
                        </div>
                        <ui.FormDescription className="text-sm leading-6">
                            If using{" "}
                            <ui.Button
                                asChild
                                variant="link"
                                className="inline-block m-0 p-0 h-fit font-normal text-sm"
                            >
                                <a
                                    target="_blank"
                                    href="https://www.england.nhs.uk/outpatient-transformation-programme/patient-initiated-follow-up-giving-patients-greater-control-over-their-hospital-follow-up-care/"
                                >
                                    Patient Initiated Follow Up (PIFU)
                                </a>
                            </ui.Button>{" "}
                            do not schedule a follow-up appointment. Instead, Patient Watch will alert you when the
                            patient may need to be seen. page.
                        </ui.FormDescription>
                    </div>
                </ui.FormItem>
            )}
        />
    );
};

export default PIFU;
